import { hash } from '@ember/helper';
import { service } from '@ember/service';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';

import AssetFormatRelation from './asset-format-relation';
import Info from './info';
import Upload from './upload';

export default class RecordDetailFormsAssetComponent extends Component {
  // Services
  @service data;
  @service flashMessages;
  @service assetUploader;

  // Defaults
  cmsStates = [1, 2, 3, 5, 7];

  // Getter and setter
  get assetFolderOptions() {
    this.data.assetFoldersGrouped.forEach((group) => {
      group.groupName = group.label;
      group.options = group.children;
    });

    return this.data.assetFoldersGrouped;
  }

  get selectedFolder() {
    let assetFolderId = this.args.model.assetFolderId;

    return this.data.assetFolders.find(
      (assetFolder) => assetFolder.value === assetFolderId,
    );
  }

  // Functions
  onUploadSuccess = async (file) => {
    try {
      this.args.model.tmpAssetName = file.uploadPath;

      this.assetUploader.history.set(file.uuid, {
        file: file,
        asset: this.args.model,
      });

      await this.args.onSaveRecord(this.args.model);
    } catch (error) {
      this.args.model.tmpAssetName = null;

      this.flashMessages.serverError(error);
    }
  };

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      {{#unless this.isVariant}}
        {{#if @model.isNew}}
          <Upload
            @asset={{@model}}
            @mediaTypeOptions={{this.mediaTypeOptions}}
            @onUploadSuccess={{this.onUploadSuccess}}
          />
        {{else}}
          {{#if @model.id}}
            <Info @asset={{@model}} />
          {{/if}}
        {{/if}}
      {{/unless}}

      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.sections.variant
            @availableLanguages={{this.availableLanguages}}
            @variantChannelActions={{hash openRecord=false openNewRecord=false}}
          />

          <form.fieldset @titleKey='generalRequirements' as |fieldset|>
            <fieldset.field
              @property='assetFolderId'
              @type='select-value'
              @selected={{this.selectedFolder}}
              @options={{this.assetFolderOptions}}
              @isSearchEnabled={{true}}
            />

            <fieldset.field @property='headline' />
            <fieldset.field @property='subHeadline' />
          </form.fieldset>

          <form.fieldset
            @titleKey='general'
            @isClosed={{@model.isNew}}
            as |fieldset|
          >
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />

            {{#if this.isParent}}
              <fieldset.field
                @property='cmsLanguageId'
                @type='select-value'
                @options={{this.availableLanguages}}
              />
            {{/if}}

            <fieldset.field @property='text' @type='text-editor' />

            <fieldset.field @property='copyright' />
            <fieldset.field @property='changeDate' @type='date-time' />
          </form.fieldset>

          {{#if @model.isVideo}}
            <form.fieldset
              @titleKey='videoSettings'
              @isClosed={{form.model.isNew}}
              as |fieldset|
            >
              <fieldset.field @property='recordPartnerId' />
              <fieldset.field @property='versiontitle' />
              <fieldset.field @property='director' />
              <fieldset.field @property='videoIsrc' />
            </form.fieldset>

          {{/if}}
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset
            @titleKey='assignments'
            @isClosed={{@model.isNew}}
            as |fieldset|
          >
            <fieldset.field
              @property='artists'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            {{#if @model.isVideo}}
              <fieldset.field
                @property='products'
                @type='has-many'
                @on={{hash openNewRecord=false}}
              />
            {{/if}}

            <fieldset.field
              @property='assetTokenConfigs'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            {{#unless @model.isNew}}
              <fieldset.field
                @property='assetFormatRelations'
                @type='has-many-join'
                @hasManyForeignModelName='asset-format'
                @on={{hash
                  openNewRecord=false
                  removeRecord=this.deleteRelation
                  openRecord=false
                }}
                as |assetFormatRelation field|
              >
                <AssetFormatRelation
                  @assetFormatRelation={{assetFormatRelation}}
                  @isDisabled={{field.isDisabled}}
                />
              </fieldset.field>
            {{/unless}}
          </form.fieldset>

          <form.fieldset
            @titleKey='channel'
            @isClosed={{@model.isNew}}
            as |fieldset|
          >
            <fieldset.field
              @property='ownedByChannel'
              @type='belongs-to'
              @on={{hash openRecord=false openNewRecord=false}}
            />

            <fieldset.field
              @property='channelsAdditive'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='channelsExcluded'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='channelsExclusive'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />
          </form.fieldset>

          <form.fieldset @titleKey='taxonomies' as |fieldset|>
            <fieldset.field @property='taxa' @type='has-many' />
          </form.fieldset>

          <form.fieldset @titleKey='keywords' as |fieldset|>
            <fieldset.field @property='keywords' />
          </form.fieldset>

          <form.sections.seo @isClosed={{@model.isNew}} />

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
